<template>
    <div class="more-filters-trigger-wrap">
        <button
            type="button"
            class="label ml-2"
            data-test="more-filters-btn"
            aria-label="Open more filters"
            @click="dialog = true"
        >
            <v-icon class="filter-icon">fal fa-filter ml-1</v-icon>
            More Filters
        </button>

        <v-dialog v-model="dialog" width="700">
            <fe-stepper-filter
                title="More Filters"
                style="height:100%;"
                :applyDisabled="applyDisabled"
                @apply="onApply"
                @close="onClose"
                dismissButtonText="Close"
            >
                <v-expansion-panels v-model="expansionPanel" accordion class="more-filters-accordion">
                    <v-expansion-panel v-if="checkShow(CoursePanel)" key="course">
                        <v-expansion-panel-header>
                            <div class="more-filters-header-row">
                                <span class="more-filters-header-title">Courses</span>
                                <div class="more-filters-header-chips">
                                    <i v-if="headerFilterChips.course.length" class="fad fa-filter more-filters-header-filter-icon" aria-hidden="true"/>
                                </div>
                            </div>
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                            <course-panel
                                ref="coursePanel"
                                :existing-filter="existingFilterByType.course"
                                :params="params"
                                @valid-change="panelValid.course = $event"
                                @invalid-change="panelInvalid.course = $event"
                                @dirty-change="panelDirty.course = $event"
                            />
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                    <v-expansion-panel v-if="checkShow(DisabilityPanel)" key="disability">
                        <v-expansion-panel-header>
                            <div class="more-filters-header-row">
                                <span class="more-filters-header-title">Disability</span>
                                <div class="more-filters-header-chips">
                                    <i v-if="headerFilterChips.disability.length" class="fad fa-filter more-filters-header-filter-icon" aria-hidden="true"/>
                                </div>
                            </div>
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                            <disability-panel
                                ref="disabilityPanel"
                                :existing-filter="existingFilterByType.disability"
                                :params="params"
                                @valid-change="panelValid.disability = $event"
                                @invalid-change="panelInvalid.disability = $event"
                                @dirty-change="panelDirty.disability = $event"
                            />
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                    <v-expansion-panel v-if="checkShow(ELPanel)" key="ell">
                        <v-expansion-panel-header>
                            <div class="more-filters-header-row">
                                <span class="more-filters-header-title">English Learner</span>
                                <div class="more-filters-header-chips">
                                    <i v-if="headerFilterChips.ell.length" class="fad fa-filter more-filters-header-filter-icon" aria-hidden="true"/>
                                </div>
                            </div>
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                            <e-l-panel
                                ref="elPanel"
                                :existing-filter="existingEllFilter"
                                :params="params"
                                @valid-change="panelValid.ell = $event"
                                @invalid-change="panelInvalid.ell = $event"
                                @dirty-change="panelDirty.ell = $event"
                            />
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                    <v-expansion-panel v-if="checkShow(EthnicityPanel)" key="ethnicity">
                        <v-expansion-panel-header>
                            <div class="more-filters-header-row">
                                <span class="more-filters-header-title">Ethnicity</span>
                                <div class="more-filters-header-chips">
                                    <i v-if="headerFilterChips.ethnicity.length" class="fad fa-filter more-filters-header-filter-icon" aria-hidden="true"/>
                                </div>
                            </div>
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                            <ethnicity-panel
                                ref="ethnicityPanel"
                                :existing-filter="existingFilterByType.ethnicity"
                                :params="params"
                                @valid-change="panelValid.ethnicity = $event"
                                @dirty-change="panelDirty.ethnicity = $event"
                            />
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                    <v-expansion-panel v-if="checkShow(MealStatusPanel)" key="meal_status">
                        <v-expansion-panel-header>
                            <div class="more-filters-header-row">
                                <span class="more-filters-header-title">Meal Status</span>
                                <div class="more-filters-header-chips">
                                    <i v-if="headerFilterChips.meal_status.length" class="fad fa-filter more-filters-header-filter-icon" aria-hidden="true"/>
                                </div>
                            </div>
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                            <meal-status-panel
                                ref="mealStatusPanel"
                                :existing-filter="existingFilterByType.meal_status"
                                :params="params"
                                @valid-change="panelValid.meal_status = $event"
                                @invalid-change="panelInvalid.meal_status = $event"
                                @dirty-change="panelDirty.meal_status = $event"
                            />
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                    <v-expansion-panel v-if="checkShow(SmartformPanel)" key="form">
                        <v-expansion-panel-header>
                            <div class="more-filters-header-row">
                                <span class="more-filters-header-title">smartFORM</span>
                                <div class="more-filters-header-chips">
                                    <i v-if="headerFilterChips.form.length" class="fad fa-filter more-filters-header-filter-icon" aria-hidden="true"/>
                                </div>
                            </div>
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                            <smartform-panel
                                ref="smartformPanel"
                                :existing-filter="existingFilterByType.form"
                                :params="params"
                                @valid-change="panelValid.form = $event"
                                @invalid-change="panelInvalid.form = $event"
                                @dirty-change="panelDirty.form = $event"
                            />
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                </v-expansion-panels>
            </fe-stepper-filter>
        </v-dialog>
    </div>
</template>

<script>
import CoursePanel from './CoursePanel'
import DisabilityPanel from './DisabilityPanel'
import ELPanel from './ELPanel'
import EthnicityPanel from './EthnicityPanel'
import MealStatusPanel from './MealStatusPanel'
import SmartformPanel from './SmartformPanel'

export default {
    name: 'MoreFiltersPanel',
    components: {
        CoursePanel,
        DisabilityPanel,
        ELPanel,
        EthnicityPanel,
        MealStatusPanel,
        SmartformPanel
    },
    inject: ['localStore'],
    props: {
        params: {
            type: Object,
            required: true
        },
        checkShow: {
            type: Function,
            default: () => true
        }
    },
    data() {
        return {
            dialog: false,
            expansionPanel: 0,
            panelValid: { course: false, disability: false, ell: false, ethnicity: false, meal_status: false, form: false },
            panelInvalid: { course: false, disability: false, ell: false, meal_status: false, form: false },
            panelDirty: { course: false, disability: false, ell: false, ethnicity: false, meal_status: false, form: false },
            CoursePanel,
            DisabilityPanel,
            ELPanel,
            EthnicityPanel,
            MealStatusPanel,
            SmartformPanel,
        }
    },
    computed: {
        /** Section keys in display order; used to map openMoreFiltersToSection to panel index */
        moreFiltersSectionKeys() {
            const keys = [
                { key: 'course', show: this.checkShow(this.CoursePanel) },
                { key: 'disability', show: this.checkShow(this.DisabilityPanel) },
                { key: 'ell', show: this.checkShow(this.ELPanel) },
                { key: 'ethnicity', show: this.checkShow(this.EthnicityPanel) },
                { key: 'meal_status', show: this.checkShow(this.MealStatusPanel) },
                { key: 'form', show: this.checkShow(this.SmartformPanel) },
            ]
            return keys.filter(c => c.show).map(c => c.key)
        },
        headerFilterChips() {
            const filters = this.params?.filters || []
            const out = {
                course: [],
                disability: [],
                ell: [],
                ethnicity: [],
                meal_status: [],
                form: [],
            }
            filters.forEach(f => {
                if (f.type === 'course') out.course.push(f)
                else if (f.type === 'disability') out.disability.push(f)
                else if (f.type === 'el_status' || f.type === 'elp_level') out.ell.push(f)
                else if (f.type === 'ethnicity') out.ethnicity.push(f)
                else if (f.type === 'meal_status') out.meal_status.push(f)
                else if (f.type === 'form') out.form.push(f)
            })
            return out
        },
        hasActiveFilters() {
            if (!this.params || !this.params.filters) return false
            const filterTypes = ['course', 'disability', 'el_status', 'elp_level', 'ethnicity', 'meal_status', 'form']
            return this.params.filters.some(f => filterTypes.includes(f.type))
        },
        existingFilterByType() {
            const filters = this.params?.filters || []
            const byType = {}
            filters.forEach(f => {
                if (f.type === 'course') byType.course = f
                else if (f.type === 'disability') byType.disability = f
                else if (f.type === 'ethnicity') byType.ethnicity = f
                else if (f.type === 'meal_status') byType.meal_status = f
                else if (f.type === 'form') byType.form = f
            })
            return byType
        },
        existingEllFilter() {
            const filters = (this.params?.filters || []).filter(f => f.type === 'el_status' || f.type === 'elp_level')
            return filters.length ? filters : null
        },
        /** Apply is enabled when form state differs from applied filters (including when a filter is cleared). */
        applyDisabled() {
            const applied = {
                course: !!this.existingFilterByType.course,
                disability: !!this.existingFilterByType.disability,
                ell: !!(this.existingEllFilter && this.existingEllFilter.length),
                ethnicity: !!this.existingFilterByType.ethnicity,
                meal_status: !!this.existingFilterByType.meal_status,
                form: !!this.existingFilterByType.form,
            }
            const formWouldApply = {
                course: this.panelValid.course,
                disability: this.panelValid.disability,
                ell: this.panelValid.ell,
                ethnicity: this.panelValid.ethnicity,
                meal_status: this.panelValid.meal_status,
                form: this.panelValid.form,
            }
            const hasStructuralChange = Object.keys(applied).some(
                key => applied[key] !== formWouldApply[key]
            )
            const hasDirtyPanel = Object.values(this.panelDirty).some(Boolean)
            const hasChange = hasStructuralChange || hasDirtyPanel
            const hasInvalidState = this.panelInvalid.course || this.panelInvalid.disability || this.panelInvalid.ell || this.panelInvalid.meal_status || this.panelInvalid.form
            return !hasChange || hasInvalidState
        },
        openMoreFiltersToSection() {
            return this.localStore?.state?.openMoreFiltersToSection
        },
    },
    watch: {
        openMoreFiltersToSection(sectionKey) {
            if (!sectionKey || typeof sectionKey !== 'string') return
            this.dialog = true
            const index = this.moreFiltersSectionKeys.indexOf(sectionKey)
            if (index >= 0) {
                this.$nextTick(() => {
                    this.expansionPanel = index
                })
            }
            this.localStore.state.openMoreFiltersToSection = null
        },
    },
    methods: {
        onClose() {
            this.dialog = false
            this.expansionPanel = 0
            this.panelValid.course = false
            this.panelValid.disability = false
            this.panelValid.ell = false
            this.panelValid.ethnicity = false
            this.panelValid.meal_status = false
            this.panelValid.form = false
            this.panelInvalid.course = false
            this.panelInvalid.disability = false
            this.panelInvalid.ell = false
            this.panelInvalid.meal_status = false
            this.panelInvalid.form = false
            this.panelDirty.course = false
            this.panelDirty.disability = false
            this.panelDirty.ell = false
            this.panelDirty.ethnicity = false
            this.panelDirty.meal_status = false
            this.panelDirty.form = false
        },
        async onApply() {
            const types = [
                { ref: 'coursePanel', type: 'course', promise: true },
                { ref: 'disabilityPanel', type: 'disability', promise: false },
                { ref: 'elPanel', type: 'ell', promise: false },
                { ref: 'ethnicityPanel', type: 'ethnicity', promise: false },
                { ref: 'mealStatusPanel', type: 'meal_status', promise: false },
                { ref: 'smartformPanel', type: 'form', promise: false },
            ]
            const results = {}
            for (const { ref, type, promise } of types) {
                const panel = this.$refs[ref]
                if (!panel || !panel.getFilter) continue
                const p = promise ? panel.getFilter() : Promise.resolve(panel.getFilter())
                const filter = await p
                if (filter != null) {
                    results[type] = Array.isArray(filter) ? filter : [filter]
                }
            }
            this.$emit('apply-more-filters', results)
            this.dialog = false
        },
    },
}
</script>

<style lang="scss" scoped>
.label {
    display: inline-flex;
    align-items: center;
    cursor: pointer;
    color: var(--v-primary-base);
    background: none;
    border: none;
    padding: 0;
    font: inherit;
}

.filter-icon {
    color: var(--v-primary-base);
    padding-right: 4px;
}

.more-filters-accordion {
    max-height: 60vh;
    overflow-y: auto;
}

.more-filters-accordion ::v-deep .fe-label {
    display: flex;
    align-items: center;
    width: fit-content;
    max-width: 100%;
}
.more-filters-accordion ::v-deep .fe-label > *:first-child {
    position: static !important;
    margin-left: 4px;
    order: 2;
}
.more-filters-accordion ::v-deep .fe-label > *:last-child {
    order: 1;
}

.more-filters-header-row {
    display: flex;
    align-items: center;
    width: 100%;
    min-width: 0;
}

.more-filters-header-title {
    flex: 0 0 auto;
}

.more-filters-header-chips {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    justify-content: flex-end;
    gap: 4px 6px;
    min-width: 0;
    margin-left: auto;
    margin-right: 20px;
}

.more-filters-header-filter-icon {
    color: #006C90;
    font-size: 1rem;
}
</style>
